export const pageview = (GA_MEASUREMENT_ID: string, url: string) => {
  window.gtag("config", GA_MEASUREMENT_ID, {
    page_path: url,
  });
};

export const gtagAvailable = (): boolean => {
  return (
    typeof window !== "undefined" &&
    typeof window.gtag !== "undefined" &&
    typeof window.gtag === "function"
  );
};
